export default __webpack_public_path__ + "static/media/antheliosSpf100.76b5a8f3.jpg";